import {
  GET_ALL_USERS,
  GET_ONE_USER,
  DELETE_USER,
  SEARCH_USERS,
  DISABLE_LODER
} from './types';

import axios from 'axios';
const URL = process.env.REACT_APP_API_URL;

const handlePost = (body, endpoint, headers = {}) => {
  let token = localStorage.getItem("uid") ? JSON.parse(localStorage.getItem("uid")).token : ""
  headers = {
    ...headers,
    "x-request-token": token
  }
  return new Promise((resolve, reject) => {
    axios.post(`${URL}${endpoint}`, body, {
      headers
    })
      .then(res => {
        resolve(res)
      })
      .catch(e => {
        console.log(e)
        reject(e)
      })
  })

}

const handleGet = (endpoint, headers = {}) => {
  let token = localStorage.getItem("uid") ? JSON.parse(localStorage.getItem("uid")).token : ""
  headers = {
    ...headers,
    "x-request-token": token
  }
  return new Promise((resolve, reject) => {
    axios.get(`${URL}${endpoint}`, {
      headers
    })
      .then(res => {
        resolve(res)
      })
      .catch(e => {
        console.log(e)
        reject(e)
      })
  })
}

export const searchUsers = (name) => {
  return { type: SEARCH_USERS, payload: name }
};

export const getAllUsers = (data=[]) => {
  return function(dispatch) {
    handleGet('/admin/getAllUsers')
    .then(res => {
      console.log(res.data)
      dispatch({ type: GET_ALL_USERS, payload: res.data.result })
    })
    .catch(e => {
      console.log(e)
    })
  }
};

export const getOneUser = (data) => {
  return function(dispatch) {
    handleGet(`/admin/getOneUser/${data}`)
    .then(res => {
      console.log(res.data)
      dispatch({ type: GET_ONE_USER, payload: res.data.result })
    })
    .catch(e => {
      console.log(e)
    })
  }
};


export const updateUser = (data, headers = {}) => {
  return function(dispatch) {
    handlePost(data, `/admin/updateUser`, headers)
    .then(res => {
      console.log(res.data)
      alert("Updated Admin")
    })
    .catch(e => {
      console.log(e)
    })
  }
};

export const addUser = (data, headers = {}) => {
  return function(dispatch) {
    handlePost(data, `/admin/add_user`, headers)
    .then(res => {
      if(res.data.status === true){
        dispatch({ type: DISABLE_LODER });
        alert("User is added.")
        console.log('add admin user res ---->', res.data)
        }else{
        alert("User is not added.")
        console.log('provider is not added --->',res.data)
        dispatch({ type: DISABLE_LODER });
        }      
    })
    .catch(e => {
      dispatch({ type: DISABLE_LODER });
      console.log(e)
    })
  }
};

export const deleteUser = (data) => {
  return { type: DELETE_USER, payload: { data } };
};